import { Welcomer /*, Events*/ } from "../components/Containers";

export default function Home(args) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Welcomer device={args.device} noBg></Welcomer>
      {/*args.device === "pc" && <Events device={args.device}></Events>*/}
    </div>
  );
}
